/* UnderlingType.enum.js */

/**
 * @typedef UnderlingType
 * @enum {string}
 */
module.exports = {
    CONTROL_ADAPTER: "control-adapter",
};
Object.freeze(module.exports);
